<template>
  <div class="new-page-con">
    <Header @onSearch="onSearch">
      <!-- 工具栏 -->
    </Header>
    <!-- 工具栏 -->
    <Tollbar
      :list="tollbarList"
      :sortList="sortList"
      :conditionsList="conditionsList"
      :selectList="selectList"
      type="1"
      theme="1"
      :isShowSearch.sync="isShowSearch"
      :isShowSelect.sync="isShowSelect"
      @onClearSearch="onClearSearch"
      @onChangeSort="onChangeSort"
    ></Tollbar>
    <div style="overflow-y: auto; height: 100%">
      <div class="CountryRisk-head">
        <div class="flex_center_start" style="margin-left: 66px">
          <img class="CountryImg" :src="CountryRiskCode" alt="" /><span
            class="China_code margin-left20"
            >{{ this.$route.query.keyword }}</span
          >
        </div>
        <div class="flex_center_start margin-top20" style="margin-left: 66px">
          <h3>
            <span class="Country-text margin-right20"
              >Country ISO : {{ this.$route.query.SOCode }}</span
            >
            <span class="Country-text margin-right20">
              Currency : {{ this.$route.query.currency }}</span
            >
            <span class="Country-text"
              >Language : {{ this.$route.query.language }}</span
            >
          </h3>
        </div>
        <div class="CountryRisk-tab flex_center">
          <ul
            class="flex_center_bettwen CountryRisk-tab-Head"
            style="width: 100%"
          >
            <li class="CountryRisk-detail-box-one">
              <span style="color: #f9722c" v-if="$route.query.Type == '2'">{{
                this.$route.query.keyword
              }}</span>
              <span style="color: #f9722c" v-else>{{
                this.$route.query.TargetCountry
              }}</span>
              <span>Sanctions</span>
              <span style="color: #f9722c" v-if="$route.query.Type == '2'">{{
                this.$route.query.TargetCountry
              }}</span>
              <span style="color: #f9722c" v-else>{{
                this.$route.query.keyword
              }}</span>
            </li>
            <li class="CountryRisk-detail-box">
              <span>
                {{ this.$route.query.sanctionDataAmount | FilterNum }}</span
              >
              <p>No. of sanctions</p>
            </li>
            <li class="CountryRisk-detail-box">
              <span> {{ this.$route.query.companyCount | FilterNum }}</span>
              <p>No. of sanctioned companies</p>
            </li>
            <li class="CountryRisk-detail-box">
              <span> {{ this.$route.query.personCount | FilterNum }}</span>
              <p>No. of sanctioned personnel</p>
            </li>
          </ul>
        </div>
      </div>

      <div class="new-content-con">
        <!-- 检索条件 -->
        <div
          class="new-search-con"
          :class="{ 'new-content-none-search': !isShowSearch }"
          v-loading="loadingSearch"
        >
          <span class="clear-search-icon" @click="onClearSearch"
            ><i class="iconfont icon-qingchu"></i> Clear All</span
          >
          <el-form
            ref="searchForm"
            label-position="top"
            :model="searchForm"
            class="new-content-search"
          >
            <!-- 国家 -->
            <el-form-item label="Sanction  ID">
              <el-input
                class="search-select-con"
                popper-class="new-search-select"
                placeholder="Search sanction ID"
                v-model="searchForm.SanctionsID"
              >
                <i
                  slot="suffix"
                  style="cursor: pointer"
                  @click="onChangeParams(searchForm.SanctionsID, 'SanctionsID')"
                  class="el-input__icon el-icon-search"
                ></i>
              </el-input>
              <!-- <el-select clearable v-model="searchForm.SanctionsID" filterable class="search-select-con"  :popper-append-to-body="false"
              popper-class="new-search-select" placeholder="Search Sanctions ID"
              @change="(val) => onChangeParams(val, 'SanctionsID')">
              <el-option v-for="(item, index) in SanctionsIDList" :key="index" :label="item" :value="item">
                <div class="flex-between-center">
                  <el-tooltip effect="light" :visible-arrow="false" :disabled="item?.length < 25"
                    :content="item.countryName" placement="right">
                    <span class="select-name">{{ item }}</span>
                  </el-tooltip>
                </div>
              </el-option>
            </el-select> -->
            </el-form-item>
            <el-form-item label="Sanctioned Type">
              <el-select
                clearable
                v-model="searchForm.ObjectofSanctions"
                filterable
                class="search-select-con"
                :popper-append-to-body="false"
                popper-class="new-search-select"
                placeholder="Select sanctioned type"
                @change="(val) => onChangeParams(val, 'ObjectofSanctions')"
              >
                <el-option
                  v-for="(item, index) in ObjectofSanctionsList"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                  <div class="flex-between-center">
                    <el-tooltip
                      effect="light"
                      :visible-arrow="false"
                      :disabled="item?.length < 25"
                      :content="item"
                      placement="right"
                    >
                      <span class="select-name">{{ item }}</span>
                    </el-tooltip>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Company/Personnel">
              <el-input
                class="search-select-con"
                popper-class="new-search-select"
                placeholder="Search company/p ersonnel"
                v-model="searchForm.CompanyPersonName"
              >
                <i
                  slot="suffix"
                  style="cursor: pointer"
                  @click="
                    onChangeParams(
                      searchForm.CompanyPersonName,
                      'CompanyPersonName'
                    )
                  "
                  class="el-input__icon el-icon-search"
                ></i>
              </el-input>
              <!-- <el-select clearable v-model="searchForm.CompanyPersonName" filterable :popper-append-to-body="false" class="search-select-con"
              popper-class="new-search-select" placeholder="Search Company/Person Name"
              @change="(val) => onChangeParams(val, 'CompanyPersonName')">
              <el-option v-for="(item, index) in CompanyPersonNameList"  :key="index" :label="item" :value="item">
                <div class="flex-between-center">
                  <el-tooltip effect="light" :visible-arrow="false"  :disabled="item?.length < 30"
                    :content="item" placement="right">
                    <span class="select-name">{{ item }}</span>
                  </el-tooltip>
                </div>
              </el-option>
            </el-select> -->
            </el-form-item>
            <el-form-item label="Sanction Type">
              <el-select
                clearable
                v-model="searchForm.Typesofanctions"
                :popper-append-to-body="false"
                filterable
                class="search-select-con"
                popper-class="new-search-select"
                placeholder="Select sanction type"
                @change="(val) => onChangeParams(val, 'Typesofanctions')"
              >
                <el-option
                  v-for="(item, index) in TypesofanctionsList"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                  <div class="flex-between-center">
                    <el-tooltip
                      effect="light"
                      :visible-arrow="false"
                      :disabled="item?.length < 25"
                      :content="item"
                      placement="right"
                    >
                      <span class="select-name">{{ item }}</span>
                    </el-tooltip>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Reference">
              <el-select
                clearable
                v-model="searchForm.ReferenceName"
                filterable
                class="search-select-con"
                :popper-append-to-body="false"
                popper-class="new-search-select"
                placeholder="Select reference"
                @change="(val) => onChangeParams(val, 'ReferenceName')"
              >
                <el-option
                  v-for="(item, index) in ReferenceNameList"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                  <div class="flex-between-center">
                    <el-tooltip
                      effect="light"
                      :visible-arrow="false"
                      :disabled="item?.length < 25"
                      :content="item"
                      placement="right"
                    >
                      <span class="select-name">{{ item }}</span>
                    </el-tooltip>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Sanction Source">
              <el-select
                clearable
                v-model="searchForm.SourceofSanctions"
                filterable
                class="search-select-con"
                :popper-append-to-body="false"
                popper-class="new-search-select"
                placeholder="Select sanction source"
                @change="(val) => onChangeParams(val, 'SourceofSanctions')"
              >
                <el-option
                  v-for="(item, index) in SourceofSanctionsList"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                  <div class="flex-between-center">
                    <el-tooltip
                      effect="light"
                      :visible-arrow="false"
                      :disabled="item?.length < 25"
                      :content="item"
                      placement="right"
                    >
                      <span class="select-name">{{ item }}</span>
                    </el-tooltip>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Status">
              <el-select
                clearable
                v-model="searchForm.Status"
                filterable
                class="search-select-con"
                :popper-append-to-body="false"
                popper-class="new-search-select"
                placeholder="Select status"
                @change="(val) => onChangeParams(val, 'Status')"
              >
                <el-option
                  v-for="(item, index) in StatusList"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                  <div class="flex-between-center">
                    <el-tooltip
                      effect="light"
                      :visible-arrow="false"
                      :disabled="item?.length < 25"
                      :content="item"
                      placement="right"
                    >
                      <span class="select-name">{{ item }}</span>
                    </el-tooltip>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="new-content-country-right">
          <!-- 列表 -->
          <div class="new-content-right">
            <div class="new-content-total">
              Found over {{ page.total | FilterNum }} “{{
                $route.query.keyword
              }}” results
            </div>
            <div class="new-table-box" v-loading="loading">
              <!-- v-loadmore="handleScroll" -->
              <el-table
                :data="tableData"
                class="new-table-con el-table table_height_30 table_font_size_14 table_padding_0 el-table--fit el-table--border el-table--scrollable-x el-table--scrollable-y el-table--enable-row-hover"
                height="100%"
              >
                <el-table-column prop="id" label="Sanction ID" width="170">
                  <template slot-scope="scope">
                    {{ scope.row?.id ? scope.row?.id : "-" }}
                  </template>
                </el-table-column>
                <el-table-column prop="id" label="Sanctioned Type " width="220">
                  <template slot-scope="scope">
                    {{
                      scope.row?.sanctionObject
                        ? scope.row?.sanctionObject
                        : "-"
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="id"
                  label="Country of Source"
                  width="200"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{
                      $route.query.Type == "2"
                        ? $route.query.keyword
                        : $route.query.TargetCountry
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="id"
                  label="Name"
                  width="230"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{
                      scope.row?.sanctionName ? scope.row?.sanctionName : "-"
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="id"
                  label="Sanctioned Countries"
                  width="200"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{
                      $route.query.Type == "1"
                        ? $route.query.keyword
                        : $route.query.TargetCountry
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="id"
                  label="Sanction Type"
                  width="180"
                  align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <div
                      class="el-badge-box flex_center"
                      v-if="scope.row?.sanctionType == 'Law Enforcement'"
                    >
                      <el-tooltip
                        effect="dark"
                        content="Law Enforcement"
                        placement="top"
                      >
                        <svg
                          t="1760326286025"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="8334"
                          width="32"
                          height="32"
                        >
                          <path
                            d="M512 972.1856c-116.3264 0-215.4496-24.1664-286.5152-69.8368-57.5488-37.0688-96.0512-87.8592-105.472-139.4688-0.2048-1.4336-0.4096-2.8672-0.4096-4.3008l-0.4096-140.9024-91.7504-113.4592c-37.888-46.8992-33.5872-113.8688 10.0352-155.648 52.6336-50.3808 133.12-123.2896 216.8832-183.0912C359.6288 90.112 446.2592 51.8144 512 51.8144c65.7408 0 152.3712 38.2976 257.6384 113.4592 83.7632 60.0064 164.2496 132.7104 216.8832 183.0912 43.6224 41.7792 48.128 108.7488 10.0352 155.648l-91.9552 113.4592-1.024 140.288c0 1.4336-0.2048 2.8672-0.4096 4.3008-9.6256 52.4288-48.7424 103.8336-107.1104 140.9024-70.8608 45.2608-168.96 69.2224-284.0576 69.2224zM168.7552 755.9168c12.288 58.9824 98.9184 167.1168 343.2448 167.1168 243.9168 0 330.3424-108.544 342.6304-167.7312l1.024-146.6368c0-5.5296 2.048-11.0592 5.5296-15.36L958.464 473.088c21.7088-26.8288 19.2512-65.1264-5.9392-89.2928C764.5184 204.1856 603.9552 100.9664 512 100.9664c-91.9552 0-252.5184 103.2192-440.5248 283.0336-24.9856 24.1664-27.648 62.464-5.9392 89.2928l97.28 120.2176c3.4816 4.3008 5.5296 9.8304 5.5296 15.36l0.4096 147.0464z m710.4512 1.8432z"
                            p-id="8335"
                            fill="#ffffff"
                          ></path>
                          <path
                            d="M512 480.8704c-8.192 0-16.5888-1.8432-23.9616-5.7344-3.6864-1.8432-7.3728-3.6864-11.4688-5.5296-37.2736-17.8176-99.5328-47.9232-99.5328-128v-76.8c0-29.2864 23.7568-53.0432 53.248-53.0432h128c13.5168 0 24.576 11.0592 24.576 24.576s-11.0592 24.576-24.576 24.576H430.08c-2.2528 0-4.096 1.8432-4.096 3.8912v76.8c0 45.6704 29.696 63.488 71.68 83.7632 4.3008 2.048 8.3968 4.096 12.288 5.9392 1.2288 0.6144 2.4576 0.6144 3.6864 0 3.6864-1.8432 7.7824-3.8912 11.8784-5.7344 42.1888-20.48 72.0896-38.2976 72.0896-83.968v-43.008c0-13.5168 11.0592-24.576 24.576-24.576s24.576 11.0592 24.576 24.576v43.008c0 79.872-62.464 110.1824-99.9424 128.2048-3.8912 1.8432-7.5776 3.6864-11.0592 5.3248-7.168 3.8912-15.5648 5.7344-23.7568 5.7344zM879.2064 782.336c-1.6384 0-3.2768-0.2048-4.9152-0.4096-2.2528-0.4096-226.5088-45.8752-362.2912-45.8752-135.7824 0-360.0384 45.4656-362.2912 45.8752-13.312 2.6624-26.2144-5.9392-29.0816-19.2512-2.6624-13.312 5.9392-26.2144 19.2512-29.0816 9.4208-1.8432 231.424-46.8992 372.1216-46.8992 140.6976 0 362.7008 45.056 372.1216 46.8992 13.312 2.6624 21.9136 15.7696 19.2512 29.0816-2.4576 11.6736-12.6976 19.6608-24.1664 19.6608zM144.7936 631.3984c-11.4688 0-21.7088-7.9872-23.9616-19.6608-2.6624-13.312 5.9392-26.2144 19.2512-29.0816 9.4208-1.8432 231.424-46.8992 372.1216-46.8992 59.392 0 140.0832 7.9872 239.8208 23.552 13.312 2.048 22.528 14.7456 20.48 28.0576s-14.7456 22.528-28.0576 20.48c-96.0512-14.9504-176.3328-22.9376-232.2432-22.9376-135.7824 0-360.0384 45.4656-362.2912 45.8752-1.8432 0.4096-3.4816 0.6144-5.12 0.6144z"
                            p-id="8336"
                            fill="#ffffff"
                          ></path>
                          <path
                            d="M622.592 235.52m-24.576 0a24.576 24.576 0 1 0 49.152 0 24.576 24.576 0 1 0-49.152 0Z"
                            p-id="8337"
                            fill="#ffffff"
                          ></path>
                        </svg>
                      </el-tooltip>
                    </div>
                    <div
                      class="el-badge-box flex_center"
                      v-if="scope.row?.sanctionType == 'Enforcement Orders'"
                    >
                      <el-tooltip
                        effect="dark"
                        content="Enforcement Orders"
                        placement="top"
                      >
                        <svg
                          t="1760513812891"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="7709"
                          width="30"
                          height="30"
                        >
                          <path
                            d="M931.855195 870.953786a17.084531 17.084531 0 0 1-17.08453 17.08453H391.646231a134.500079 134.500079 0 0 1-19.975259 33.162179v24.262632a78.634313 78.634313 0 0 1-78.569353 78.536873h-81.849843a78.666794 78.666794 0 0 1-78.536873-75.841025q-6.496019-21.696704-12.634758-43.555809c-0.227361-0.812002-0.552162-1.494084-0.779522-2.273607v-0.617122c-14.486123-52.617756-32.869858-128.686142-25.984077-154.637739a393.269008 393.269008 0 0 1 101.792622-114.102579 15.915247 15.915247 0 0 1 1.721445-1.071843l18.221334-10.10131V17.669172a17.084531 17.084531 0 0 1 17.084531-17.08453h543.489453a17.084531 17.084531 0 0 1 2.630888-0.519682 16.79221 16.79221 0 0 1 13.186919 6.496019l133.915438 133.915438a16.72725 16.72725 0 0 1 6.496019 13.186919v717.29045zM228.368787 662.236686c-0.552162-2.923209-0.779522-5.586577-1.071843-8.314905l-12.992039 7.275542a427.113268 427.113268 0 0 0-88.053541 94.906842 528.613569 528.613569 0 0 0 26.763599 139.144733c7.080661 24.197672 20.819742 24.392552 25.984077 24.392552h5.131855a17.084531 17.084531 0 0 1 0 34.136582h-5.131855a62.459225 62.459225 0 0 1-11.432994-1.104324 44.367812 44.367812 0 0 0 43.65325 37.189711h81.849843a44.302852 44.302852 0 0 0 44.043011-40.567641 16.95461 16.95461 0 0 1-10.848353-29.232087 94.19228 94.19228 0 0 0 36.702509-100.331017 205.858851 205.858851 0 0 0-22.281346-54.144321 166.817775 166.817775 0 0 1-25.529356-108.288642 178.64053 178.64053 0 0 0-8.477305-94.711961 19.488058 19.488058 0 0 0-20.36502-16.240048 17.279411 17.279411 0 0 0-16.987091 14.388683 18.318774 18.318774 0 0 1-0.682082 2.371047 168.37682 168.37682 0 0 0-6.658419 93.152916 223.073302 223.073302 0 0 1-8.022584 95.231643 17.506772 17.506772 0 0 1-1.201764 2.793288l-34.169061 63.660989a17.084531 17.084531 0 0 1-30.07657-16.240048l5.586577-10.458591-11.368034-6.496019a17.084531 17.084531 0 1 1 17.214451-29.491928l10.296191 6.008818 11.627874-21.696704a187.962318 187.962318 0 0 0 6.49602-77.27015zM795.43879 58.951375v77.62743h77.757351z m102.409744 111.828972h-119.494274a17.084531 17.084531 0 0 1-17.084531-17.052051V34.721223H249.091088v493.470105a51.383513 51.383513 0 0 1 36.182828-16.240048 53.88448 53.88448 0 0 1 54.04688 40.37276 212.09503 212.09503 0 0 1 9.744029 108.613442 134.88984 134.88984 0 0 0 21.794145 88.378343A237.916706 237.916706 0 0 1 396.323365 812.099851a143.432106 143.432106 0 0 1 3.24801 41.574523h498.179719V170.715387z m-389.111555 530.140134a301.545215 301.545215 0 0 0 54.306721-21.339423 153.598376 153.598376 0 0 1 27.478162-74.217021 66.551718 66.551718 0 0 1 77.270149-21.112063 27.802963 27.802963 0 0 1 20.884702 27.478162c-0.747042 26.698639-44.660133 62.459225-93.250357 89.190345a180.069655 180.069655 0 0 0 2.468488 48.232943 243.275922 243.275922 0 0 0 31.862974-31.050972c3.637771-4.027532 7.308022-8.022584 10.848353-11.790275a17.084531 17.084531 0 0 1 28.127763 5.034415l1.071843 2.630888 2.598408-2.208647c21.274463-18.156374 31.960415-27.283281 45.731976-22.118946a22.736067 22.736067 0 0 1 14.161322 19.488058l0.22736 1.656485c6.203698-5.359216 13.966441-12.082596 23.807911-20.040219a25.366955 25.366955 0 0 1 20.722302-6.301139 26.731119 26.731119 0 0 1 17.993973 15.655406c0.389761 0.682082 0.779522 1.429124 1.234244 2.143687a17.084531 17.084531 0 0 1 19.877819 27.413201 31.018492 31.018492 0 0 1-46.706379-5.846417c-6.918261 5.748977-12.439877 10.588511-16.98709 14.551083-15.655406 13.60916-24.295112 21.144543-36.83243 16.434929-9.744029-3.670251-12.797158-11.952675-14.681003-22.736068l-6.49602 5.619057c-6.8533 5.846417-15.005805 12.797158-24.587433 20.527421a17.019571 17.019571 0 0 1-25.984077-5.391696c-17.084531 18.188854-32.739937 32.187776-49.337266 32.187776h-2.988169a28.939766 28.939766 0 0 1-22.053985-14.843405 124.041488 124.041488 0 0 1-8.996987-51.968154 311.516605 311.516605 0 0 1-43.068608 15.687887 17.084531 17.084531 0 0 1-8.932027-32.934818z m143.464586-85.585054a45.212294 45.212294 0 0 0-10.523551-1.364164 29.459447 29.459447 0 0 0-23.41815 11.400514 85.585054 85.585054 0 0 0-15.687886 31.603133 195.692581 195.692581 0 0 0 49.532147-41.704443z m126.055254-137.390808H368.585363a17.084531 17.084531 0 0 1 0-34.136581h409.671456a17.084531 17.084531 0 1 1 0 34.136581z m0-68.208203H368.585363a17.084531 17.084531 0 1 1 0-34.104101h409.671456a17.084531 17.084531 0 1 1 0 34.136582z m0-68.208202H368.585363a17.084531 17.084531 0 0 1 0-34.136581h409.671456a17.084531 17.084531 0 1 1 0 34.136581zM368.585363 170.877787h68.208203a17.084531 17.084531 0 0 1 0 34.136582h-68.208203a17.084531 17.084531 0 0 1 0-34.136582z m170.715387-34.104101H368.585363a17.084531 17.084531 0 1 1 0-34.136581h170.715387a17.084531 17.084531 0 0 1 0 34.136581zM368.585363 512.178641h136.416405a17.084531 17.084531 0 1 1 0 34.136581h-136.416405a17.084531 17.084531 0 0 1 0-34.136581z"
                            p-id="7710"
                            fill="#ffffff"
                          ></path>
                        </svg>
                      </el-tooltip>
                    </div>
                    <div
                      class="el-badge-box flex_center"
                      v-if="scope.row?.sanctionType == 'Warnings'"
                    >
                      <el-tooltip
                        effect="dark"
                        content="Warnings"
                        placement="top"
                      >
                        <svg
                          t="1760513992905"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="7961"
                          width="30"
                          height="30"
                        >
                          <path
                            d="M484 428v224c0 15.5 12.5 28 28 28s28-12.5 28-28V428c0-15.5-12.5-28-28-28s-28 12.5-28 28zM484 764a28 28 0 1 0 56 0 28 28 0 1 0-56 0z"
                            fill="#ffffff"
                            p-id="7962"
                          ></path>
                          <path
                            d="M952.6 825.1l-393.2-681c-10.5-18.2-29-27.4-47.4-27.4s-36.9 9.1-47.4 27.4l-393.2 681c-21.1 36.5 5.3 82.1 47.4 82.1h786.4c42.1 0 68.5-45.6 47.4-82.1z m-832.7 28L512 174l393.2 677.2-785.3 1.9z"
                            fill="#ffffff"
                            p-id="7963"
                          ></path>
                        </svg>
                      </el-tooltip>
                    </div>
                    <div
                      class="el-badge-box flex_center"
                      v-if="scope.row?.sanctionType == 'Financial Sanctions'"
                    >
                      <el-tooltip
                        effect="dark"
                        content="Financial Sanctions"
                        placement="top"
                      >
                        <svg
                          t="1760514051368"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="8172"
                          width="30"
                          height="30"
                        >
                          <path
                            d="M191.614 1005.632c-22.37 0-40.37-17.983-40.37-40.277 0-21.988 18.001-40.01 40.37-40.01l93.427 0 0-44.299c0-11.129 3.983-20.571 10.841-28.022l1.723-2.276c8.004-7.699 18.231-12.583 30.297-12.583l142.61 0 0-658.942c-13.443 3.139-26.278 6.837-38.843 12.275-11.796 5.115-23.214 11.396-34.282 18.562-10.61 7.737-21.184 16.297-30.032 25.741-22.907 22.29-50.295 40.545-80.633 53.147-15.091 6.281-30.795 11.702-47.996 15.415-6.321 1.168-12.832 1.994-18.885 3.143l103.422 316.074c5.515 1.991 10.956 5.113 15.477 9.98 15.397 15.474 15.397 41.158 0 56.306-19.46 19.727-43.363 36.007-69.717 47.155l0 0c-25.663 9.974-53.204 16.012-81.742 16.012-29.152 0-57.152-6.037-82.279-16.012l-2.337-1.132c-25.665-11.147-48.532-26.297-67.415-46.023-15.668-15.15-15.668-40.833 0-56.306 4.557-4.867 9.73-7.988 15.438-9.98l103.999-316.631c-5.399-0.861-10.269-1.415-15.438-2.585-17.124-3.713-33.134-9.135-47.958-15.415-15.475-5.729-30.031-13.732-42.902-22.601-13.71-8.869-26.275-19.421-37.691-30.546-9.115-10.001-9.115-25.741 0-34.323 9.423-9.98 25.127-9.98 34.285 0 9.153 8.582 19.456 17.429 30.031 24.879 11.146 7.145 22.484 13.714 34.553 18.847 12.293 4.863 25.166 8.886 38.572 11.722 12.909 2.566 26.585 4.005 40.909 4.005 13.945 0 27.734-1.438 40.529-4.005 13.098-2.835 26.354-6.858 38.917-11.722 23.939-9.997 45.965-25.435 64.58-43.725l0.537-0.556c11.414-11.414 23.406-21.698 37.156-30.567 12.563-8.867 27.427-16.318 42.289-22.598 15.401-6.838 31.412-11.99 47.959-14.864l9.5-2.281 0-76.285c0-22.292 18.538-40.604 40.794-40.604 22.027 0 40.107 18.311 40.107 40.604l0 76.285 9.652 2.281c16.547 2.874 32.868 8.026 48.035 14.864 15.398 6.283 29.725 13.732 42.903 22.598 13.102 8.869 25.894 19.422 37.078 31.123 9.502 8.582 19.461 17.429 30.339 24.879 11.414 7.145 22.831 13.714 34.588 18.847 12.222 4.863 25.169 8.886 38.499 11.722 13.254 2.566 26.354 4.005 40.642 4.005 14.287 0 28.002-1.438 40.565-4.005 13.709-2.835 26.275-6.858 38.838-11.722 24.057-9.997 46.045-25.435 64.583-43.725 9.424-9.98 25.202-9.98 34.322 0 9.118 8.582 9.118 24.322 0 34.323-22.83 22.29-49.719 40.545-80.288 53.147-15.167 6.281-31.18 11.702-47.995 15.415-4.903 1.168-10.075 1.723-15.743 2.585l104.265 316.631c5.441 1.991 10.575 5.113 15.207 9.98 16.013 15.474 16.013 41.158 0 56.306-19.42 19.727-43.13 36.007-69.754 47.155-25.129 9.974-53.165 16.012-82.047 16.012-28.805 0-56.233-6.037-81.708-16.012l-2.031-1.132c-25.969-11.147-48.57-26.297-67.683-46.023-15.668-15.15-15.668-40.833 0-56.306 4.331-4.867 9.997-7.988 15.132-9.98l104.035-316.074c-6.894-1.149-13.097-1.975-19.456-3.143-16.815-3.713-33.097-9.135-47.958-15.415-15.436-5.729-29.991-13.732-42.903-22.601-13.175-8.869-26.275-19.421-37.078-30.546-9.808-9.444-19.765-18.004-30.953-25.741-10.801-7.165-22.291-13.446-34.321-18.562-11.91-5.439-25.127-9.136-38.764-12.275l0 0 0 658.942 142.878 0c11.684 0 22.789 4.883 30.187 12.583 8.121 7.449 12.598 18.596 12.598 30.298l0 44.299 93.811 0c22.214 0 39.987 18.022 39.987 40.01 0 22.293-17.774 40.277-39.987 40.277l-639.276 0zM925.424 637.579l0 0-90.322-275.182-89.941 275.182c11.34 10.286 23.901 18.293 37.081 24.573l1.763 0.289c15.668 6.567 33.131 9.997 51.099 9.997 18.617 0 35.775-3.429 51.177-9.997l0.611 0c13.674-6.013 27.347-14.019 38.533-24.862l0 0zM276.995 637.579l0 0-89.708-275.182-90.323 275.182c10.877 10.286 23.44 18.293 37.23 24.573l1.689 0.289c15.36 6.567 32.825 9.997 51.405 9.997 17.695 0 35.392-3.429 50.639-9.997l0.267 0c13.981-6.013 27.389-14.019 38.803-24.862l0 0zM333.075 925.344l0 0 356.006 0 0-38.61c-165.707 0-184.592 0-356.006 0l0 38.61z"
                            fill="#ffffff"
                            p-id="8173"
                          ></path>
                        </svg>
                      </el-tooltip>
                    </div>
                    <div
                      class="el-badge-box flex_center"
                      v-if="scope.row?.sanctionType == 'Exclusion List'"
                    >
                      <el-tooltip
                        effect="dark"
                        content="Exclusion List"
                        placement="top"
                      >
                        <svg
                          t="1760514097270"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="8461"
                          width="30"
                          height="30"
                        >
                          <path
                            d="M885.333333 981.333333H181.333333a53.393333 53.393333 0 0 1-53.333333-53.333333V224a53.393333 53.393333 0 0 1 53.333333-53.333333h53.333334a21.333333 21.333333 0 0 1 0 42.666666h-53.333334a10.666667 10.666667 0 0 0-10.666666 10.666667v704a10.666667 10.666667 0 0 0 10.666666 10.666667h704a10.666667 10.666667 0 0 0 10.666667-10.666667V224a10.666667 10.666667 0 0 0-10.666667-10.666667h-53.333333a21.333333 21.333333 0 0 1 0-42.666666h53.333333a53.393333 53.393333 0 0 1 53.333334 53.333333v704a53.393333 53.393333 0 0 1-53.333334 53.333333z m-522.666666-170.666666a21.266667 21.266667 0 0 1-15.086667-6.246667l-42.666667-42.666667a21.333333 21.333333 0 0 1 30.173334-30.173333l27.58 27.586667 70.246666-70.253334a21.333333 21.333333 0 0 1 30.173334 30.173334l-85.333334 85.333333A21.266667 21.266667 0 0 1 362.666667 810.666667z m384-42.666667H533.333333a21.333333 21.333333 0 0 1 0-42.666667h213.333334a21.333333 21.333333 0 0 1 0 42.666667zM362.666667 640a21.266667 21.266667 0 0 1-15.086667-6.246667l-42.666667-42.666666a21.333333 21.333333 0 0 1 30.173334-30.173334L362.666667 588.5l70.246666-70.253333a21.333333 21.333333 0 0 1 30.173334 30.173333l-85.333334 85.333333A21.266667 21.266667 0 0 1 362.666667 640z m384-42.666667H533.333333a21.333333 21.333333 0 0 1 0-42.666666h213.333334a21.333333 21.333333 0 0 1 0 42.666666zM362.666667 469.333333a21.266667 21.266667 0 0 1-15.086667-6.246666l-42.666667-42.666667a21.333333 21.333333 0 0 1 30.173334-30.173333L362.666667 417.833333l70.246666-70.253333a21.333333 21.333333 0 0 1 30.173334 30.173333l-85.333334 85.333334A21.266667 21.266667 0 0 1 362.666667 469.333333z m384-42.666666H533.333333a21.333333 21.333333 0 0 1 0-42.666667h213.333334a21.333333 21.333333 0 0 1 0 42.666667z m0-170.666667H320a21.333333 21.333333 0 0 1-21.333333-21.333333c0-26.046667 13.273333-50.786667 38.38-71.546667 19.54-16.153333 46.053333-29.666667 77.186666-39.38a129.22 129.22 0 0 1 41.453334-54.84 128 128 0 0 1 155.293333 0 129.22 129.22 0 0 1 41.453333 54.84c31.133333 9.713333 57.653333 23.226667 77.186667 39.38C754.726667 183.88 768 208.62 768 234.666667a21.333333 21.333333 0 0 1-21.333333 21.333333z m-398.38-42.666667h370.093333c-4.493333-6.926667-10.493333-12.82-15.953333-17.333333-17.166667-14.193333-42.14-26.066667-72.226667-34.32a21.333333 21.333333 0 0 1-14.853333-14.666667C604.893333 110.666667 571.166667 85.333333 533.333333 85.333333s-71.56 25.333333-82 61.673334a21.333333 21.333333 0 0 1-14.853333 14.666666c-30.1 8.26-55.073333 20.133333-72.24 34.326667-5.46 4.513333-11.46 10.406667-15.953333 17.333333z"
                            fill="#ffffff"
                            p-id="8462"
                          ></path>
                        </svg>
                      </el-tooltip>
                    </div>
                    <div
                      class="el-badge-box flex_center"
                      v-if="scope.row?.sanctionType == 'Trade Restrictions'"
                    >
                      <el-tooltip
                        effect="dark"
                        content="Trade Restrictions"
                        placement="top"
                      >
                        <svg
                          t="1760930174719"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="8412"
                          width="30"
                          height="30"
                        >
                          <path
                            d="M768.044514 422.493453c-0.233314 0-0.476861 0-0.711198 0.010233C730.276329 299.016211 614.021581 208.430076 476.40941 207.427236c-0.751107-0.00921-1.50119-0.01842-2.252297-0.01842-0.032746 0-0.065492-0.005117-0.098237-0.005117-0.033769 0-0.065492 0.005117-0.098237 0.005117-0.740874 0.001023-1.481747 0.00921-2.222621 0.01842-167.437453 1.226944-303.268048 135.090744-303.268048 299.452139s135.830595 298.235428 303.268048 299.461349c0.759293 0.00921 1.51961 0.01842 2.278903 0.019443 0.014326 0 0.027629 0.002047 0.041956 0.002047 0.014326 0 0.027629-0.002047 0.041956-0.002047 0.769526 0 1.539053-0.00921 2.308579-0.019443 63.281255-0.457418 122.056893-19.86749 170.678264-52.710502 22.00927 17.745153 48.1353 30.759561 76.743872 37.446867-68.489884 58.131979-157.02122 91.412966-251.637134 91.412966-141.309376 0-271.962042-77.064166-338.526063-197.968817l54.483892 17.984606c8.963139 3.004427 18.609847-1.928932 21.563108-10.858302 2.953262-8.963139-1.912559-18.609847-10.858302-21.563108l-91.239004-30.116925c-4.541433-1.51961-9.543354-1.041726-13.726629 1.331321-4.183276 2.339278-7.187703 6.351662-8.263198 11.029194l-19.753903 85.638449c-2.117221 9.185196 3.602038 18.35402 12.80463 20.470217 1.297552 0.290619 2.577708 0.426719 3.858888 0.426719 7.767917 0 14.802124-5.343705 16.612353-13.214976l8.659217-37.516452c73.665767 127.58991 213.471906 208.504778 364.385011 208.504778 113.77323 0 219.495086-44.290739 296.64828-120.499421 104.758925-0.418532 189.855022-84.064604 189.855022-186.817849C958.697715 506.304278 873.173876 422.493453 768.044514 422.493453zM203.172329 523.95324l92.844571 0 0 0c1.119497 34.907021 5.636371 68.041676 13.024641 98.519828l-79.284741 0C214.774575 592.355119 205.469652 559.074132 203.172329 523.95324zM344.822466 391.349129l112.163569 0 0 98.456383L330.202491 489.805512l0 0 0 0C331.47753 454.900537 336.616574 421.591921 344.822466 391.349129zM577.858964 622.472044l-86.727247 0 0-98.519828 107.35403 0c-13.482059 25.601074-21.093411 54.628178-21.093411 85.368296C577.391313 613.740172 577.547879 618.130156 577.858964 622.472044zM617.943914 489.805512 617.943914 489.805512 617.943914 489.805512l-126.812197 0 0-98.456383L603.324962 391.349129C611.529831 421.591921 616.668875 454.900537 617.943914 489.805512zM491.131717 357.202425l0-113.709785c41.377386 9.43386 77.994352 52.661384 101.171214 113.709785L491.131717 357.202425zM456.986035 243.502873l0 113.699552-101.141538 0C379.020336 296.17449 415.617859 252.957199 456.986035 243.502873zM330.202491 523.95324l126.782521 0 0 98.519828L344.832699 622.473067C336.617597 592.217996 331.47753 558.87868 330.202491 523.95324zM456.986035 656.609539l0 113.645316c-41.348734-9.444093-77.93807-52.642964-101.124142-113.645316L456.986035 656.609539zM491.131717 770.265088 491.131717 656.609539l92.450598 0c1.100054 4.15667 2.355651 8.244778 3.747347 12.274558C564.066843 723.384361 529.667382 761.472841 491.131717 770.265088zM650.523937 462.306204c-2.121314-24.849968-5.995551-48.618301-11.406794-70.957075l79.305207 0c5.499248 11.056823 10.228969 22.541389 14.131859 34.395368C702.037171 431.391101 674.062026 444.200848 650.523937 462.306204zM698.102558 357.202425l-68.828598 0c-12.800537-38.010709-30.42801-70.579475-51.579749-95.556333C626.683972 281.483906 668.480914 314.958298 698.102558 357.202425zM370.453217 261.646092c-21.151739 24.976858-38.779212 57.545624-51.579749 95.556333l-68.828598 0C279.675724 314.958298 321.472666 281.483906 370.453217 261.646092zM229.734288 391.349129l79.295997 0c-7.387247 30.456662-11.904121 63.570851-13.013385 98.456383l0 0-92.844571 0 0 0 0 0C205.459419 454.715319 214.764342 421.445588 229.734288 391.349129zM250.080685 656.609539l68.810179 0c12.800537 37.983079 30.40959 70.543659 51.561329 95.502098C321.490062 732.283032 279.701307 698.827059 250.080685 656.609539zM577.693188 752.111636c10.658757-12.567223 20.412912-27.070542 29.095665-43.219337 4.594645 7.135514 9.67536 13.948687 15.204283 20.383236C608.054683 738.152716 593.239256 745.82342 577.693188 752.111636zM798.181905 763.939009c-9.763364 1.810229-19.837814 2.764973-30.137391 2.764973-5.811356 0-11.564383-0.301875-17.220197-0.905626-29.514197-3.065825-56.671721-13.978363-79.255065-30.54569-9.315156-6.842849-17.86181-14.649652-25.464975-23.264866-9.568936-10.843976-17.658172-22.972201-23.946388-36.084846l-7.699356-19.293415c-3.533476-10.912537-5.869684-22.339798-6.862291-34.137495-0.379647-4.331655-0.564865-8.721639-0.564865-13.150508 0-0.564865 0-1.13894 0.010233-1.703805 0.185218-16.742313 3.056616-32.872688 8.216125-47.988967 4.322445-12.68388 10.259668-24.656563 17.570167-35.675524l0 0 19.526729-23.985274c1.757017-1.77646 3.554966-3.511987 5.39487-5.205559 0.919952-0.847298 1.850138-1.683339 2.790556-2.509147s1.892093-1.642406 2.852978-2.447748l0 0 0 0c21.453614-17.978467 47.794539-30.54569 76.782757-35.500539 9.05319-1.557472 18.368346-2.365884 27.868721-2.365884 2.180666 0 4.351098 0.038886 6.502088 0.12689 85.786829 3.348258 154.520259 72.606645 154.520259 157.255557C929.066861 686.035732 872.619244 750.105956 798.181905 763.939009z"
                            p-id="8413"
                            fill="#ffffff"
                          ></path>
                          <path
                            d="M103.299691 351.36344c8.485255 4.183276 18.694781 0.717338 22.878057-7.734148 63.784722-129.004119 199.618387-212.355479 346.020758-212.355479 140.90517 0 269.708721 75.480088 336.780303 194.802708l-46.743604-15.432481c-8.980535-2.970658-18.609847 1.912559-21.563108 10.858302-2.970658 8.946766 1.912559 18.609847 10.858302 21.563108l91.255377 30.134321c1.741667 0.563842 3.550873 0.853437 5.343705 0.853437 2.902096 0 5.78782-0.733711 8.382924-2.185782 4.183276-2.356674 7.187703-6.368034 8.263198-11.04659L884.529505 275.200806c2.117221-9.185196-3.619434-18.336624-12.80463-20.470217-9.134031-2.066055-18.35402 3.619434-20.47124 12.80463l-10.486842 45.472658C768.281921 180.898023 626.915239 97.128131 472.197482 97.128131c-159.291936 0-307.145355 90.811262-376.632963 231.357252C91.382267 336.936869 94.848205 347.181187 103.299691 351.36344z"
                            p-id="8414"
                            fill="#ffffff"
                          ></path>
                          <path
                            d="M817.032228 513.095961l-35.970236 66.556858c-5.164626 9.628288-8.752338 16.759709-10.764158 21.398356-2.362814-5.776563-5.690606-12.515035-9.976212-20.216437l-38.071084-67.738777L695.995571 513.095961l53.296857 93.336782-44.76453 0 0 19.429515 54.479799 0 0 18.771529-54.479799 0 0 18.247596 54.479799 0 0 42.664705 23.629163 0 0-42.664705 54.085826 0 0-18.247596-54.085826 0 0-18.771529 54.085826 0 0-19.429515-44.76453 0 53.166897-93.336782L817.032228 513.095961z"
                            p-id="8415"
                            fill="#ffffff"
                          ></path>
                        </svg>
                      </el-tooltip>
                    </div>
                    <div
                      class="el-badge-box flex_center"
                      v-if="scope.row?.sanctionType == 'Visa/Travel Ban'"
                    >
                      <el-tooltip
                        effect="dark"
                        content="Visa/Travel Ban"
                        placement="top"
                      >
                        <svg
                          t="1760930232938"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="8620"
                          width="30"
                          height="30"
                        >
                          <path
                            d="M1002.41152 113.536a192.768 192.768 0 0 0-174.08-11.989333l-195.072 86.144-147.456-58.752a320.981333 320.981333 0 0 0-161.237333-43.562667H234.66752a21.333333 21.333333 0 0 0-12.8 38.4l206.08 154.581333-220.842667 97.450667a21.077333 21.077333 0 0 1-21.632-2.986667L110.37952 312.746667a64.170667 64.170667 0 0 0-39.978667-14.037334H21.376853a21.333333 21.333333 0 0 0-18.688 31.658667l68.181334 123.093333a21.333333 21.333333 0 0 0 37.333333-20.693333L57.558187 341.333333h12.842666c4.821333 0 9.557333 1.664 13.312 4.693334l75.136 60.074666a64 64 0 0 0 65.237334 8.832l254.464-112.298666a21.290667 21.290667 0 0 0 4.181333-36.608L298.710187 128h25.941333c49.066667 0 97.365333 13.056 142.592 39.168l158.592 63.445333c5.333333 2.133333 11.306667 2.048 16.554667-0.298666l202.965333-89.6c43.861333-18.645333 94.378667-15.104 137.301333 10.709333L392.448853 437.12a21.333333 21.333333 0 0 0 18.56 38.442667L1003.094187 188.8c13.184-8.106667 20.992-22.229333 20.906666-37.674667s-8.064-29.482667-21.589333-37.589333zM234.710187 469.290667a233.813333 233.813333 0 0 0-165.546667 68.522666l-0.384 0.256-0.256 0.384a233.941333 233.941333 0 0 0-68.48 165.504c0 129.408 105.258667 234.666667 234.666667 234.666667A233.898667 233.898667 0 0 0 399.91552 870.4c0.213333-0.213333 0.512-0.256 0.725333-0.469333 0.213333-0.213333 0.256-0.469333 0.469334-0.682667a233.941333 233.941333 0 0 0 68.266666-165.290667c0-129.408-105.258667-234.666667-234.666666-234.666666z m0 426.666666a192.213333 192.213333 0 0 1-192-192c0-45.226667 16.384-86.314667 42.624-119.168L353.83552 853.333333a190.165333 190.165333 0 0 1-119.125333 42.624zM384.000853 823.168L115.49952 554.666667c32.853333-26.282667 73.941333-42.666667 119.210667-42.666667 105.856 0 192 86.144 192 192A190.208 190.208 0 0 1 384.000853 823.168z"
                            p-id="8621"
                            fill="#ffffff"
                          ></path>
                        </svg>
                      </el-tooltip>
                    </div>
                    <div
                      class="el-badge-box flex_center"
                      v-if="scope.row?.sanctionType == 'War Crimes'"
                    >
                      <el-tooltip
                        effect="dark"
                        content="War Crimes"
                        placement="top"
                      >
                        <svg
                          t="1760514157561"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="8833"
                          width="32"
                          height="32"
                        >
                          <path
                            d="M789.730514 323.776586c-0.32313-1.292521-0.646261-2.585043-1.615651-3.877564-2.908173-4.200694-5.493216-7.755128-6.785737-9.69391-2.585043-3.554434-7.431997-5.170085-11.955822-3.554434-8.401388 2.908173-16.802777 5.493216-25.204165 8.401389-28.112338 9.370779-54.609025 18.095298-81.105712 27.789208-29.40486 10.663301-58.809719 21.649732-88.214579 32.959293-14.217734-38.129378-53.316504-53.316504-56.870937-54.609025h-0.32313c-0.646261-0.32313-1.292521-0.32313-1.615652-0.32313h-21.003471c22.295992-9.69391 39.4219-29.72799 45.238245-54.285895 0 0 0.32313 0 0.323131 0.32313 1.938782 1.292521 3.877564 1.938782 6.139476 1.938782 1.615652 0 2.908173-0.32313 4.523824-0.969391 3.554434-1.615652 5.816346-4.846955 6.139477-8.724518 0.32313-4.846955 0.969391-10.34017 0.969391-15.510256 0-59.45598-42.006942-105.663616-95.323446-105.663616s-95.323446 46.530767-95.323446 105.663616c0 5.493216 0.32313 10.663301 0.969391 15.510256 0.32313 3.554434 2.585043 7.108867 5.816346 8.724518s7.431997 1.292521 10.34017-0.64626c0.32313-0.32313 0.646261-0.32313 0.969391-0.646261 5.493216 24.557905 23.265383 44.591985 46.207637 54.609025h-9.04765H422.008204l-53.962764 13.248343c-1.615652 0-3.554434 0.32313-5.170085 0.969391-40.714421 20.03408-82.075103 86.922057-80.782581 129.575261v0.32313c0.646261 11.309561 7.755128 22.619123 14.540864 28.758599 4.846955 4.523825 10.01704 9.047649 15.187126 13.571474-1.938782 0.646261-3.877564 1.292521-5.816346 2.261912-14.863995 7.431997-30.697381 14.217734-46.207637 20.35721-6.462607 2.585043-13.248343 5.493216-19.71095 8.401389-3.877564 1.615652-6.462607 5.493216-6.462606 9.69391 0 1.615652 0 2.908173-0.32313 4.846954-0.32313 2.585043 0 4.846955 1.292521 7.108868 4.200694 7.108867 8.401388 14.540865 12.602083 21.649731 6.785737 11.632692 13.571474 23.911644 21.003471 35.544336v0.32313c6.462607 9.69391 13.894604 18.741559 24.557904 20.034081h2.585043c9.370779 0 17.449038-6.139476 24.234774-12.602083 13.571474-12.925213 26.173556-26.496687 39.4219-40.714421 3.231303-3.231303 6.139476-6.785737 9.37078-10.34017-4.523825 41.360682-21.649732 181.922373-30.374251 252.364783-1.938782 14.217734 1.938782 28.112338 10.986431 39.4219 8.724519 11.309561 21.326601 18.418429 35.544336 20.357211 1.938782 0.32313 3.877564 0.32313 6.139476 0.32313 11.309561 0 22.295992-3.877564 31.343641-10.986431 10.663301-8.401388 17.125907-20.680341 18.418429-34.251815 6.462607-68.503629 18.741559-198.72515 22.942253-237.823919h11.309561c5.816346 55.255286 18.741559 191.939413 22.619123 234.915746 1.292521 14.217734 8.401388 26.819817 19.38782 35.867467 11.309561 8.724519 25.527296 12.602083 39.74503 10.6633 26.496687-3.877564 45.238246-28.435469 42.006942-54.609025-3.877564-35.221205-11.632692-95.646576-19.38782-154.133165-7.755128-58.809719-14.863995-114.065005-17.449037-139.5923-0.32313-2.585043-1.615652-5.170085-3.554434-6.785737-2.585043-3.877564-5.170085-7.431997-7.755127-11.309561-9.370779-13.571474-18.418429-26.496687-26.496687-40.068161v-0.32313c-2.261912-3.877564-3.877564-9.370779-3.877564-16.479647l0.32313-0.32313c13.248343 3.554434 23.911644-3.554434 31.343642-8.078258 1.938782-1.292521 3.554434-2.261912 5.170085-3.231303 17.772168-9.370779 36.190596-18.095298 54.285895-26.173557 31.020511-14.217734 63.010413-29.081729 92.415273-48.792679 15.187125-10.663301 33.605554-17.125907 53.316503-23.911644 8.724519-2.908173 17.772168-6.139476 26.496687-9.693909 3.877564-1.615652 6.462607-5.493216 6.462606-9.69391 0.646261-1.938782 0.646261-4.846955 0-8.078258zM462.722625 158.333859c40.714421 0 72.704323 35.544336 73.996845 81.428842-20.35721-9.69391-46.207636-14.863995-73.673714-14.863995-27.789208 0-53.316504 5.170085-74.643105 15.187125 1.292521-46.207636 33.605554-81.751972 74.319974-81.751972z m-57.194067 97.585358c16.802777-6.462607 36.836857-9.69391 57.517198-9.693909 21.003471 0 41.037551 3.554434 57.517198 9.693909-3.554434 28.435469-28.112338 49.76207-56.870938 49.76207-29.40486 0-54.609025-21.649732-58.163458-49.76207z m84.013884 85.629537l-20.68034 21.326601-20.034081-21.326601h40.714421z m-186.446197 122.143262c-0.969391-34.251814 34.251814-91.122752 66.887977-108.894919 0.32313 0 0.969391 0 1.292521-0.32313L420.392553 342.518145l40.39129 42.976333c1.938782 2.261912 4.846955 3.231303 7.755128 3.231303 2.908173 0 5.493216-1.292521 7.755128-3.231303l40.391291-42.006942c10.34017 5.170085 30.374251 17.449038 38.452508 39.745029-11.955822 4.523825-23.911644 9.370779-35.544335 13.894604-5.493216 2.261912-9.69391 5.816346-13.248344 9.37078-1.615652 1.292521-2.908173 2.908173-4.523824 3.877564l-0.323131 0.32313s-0.32313 0-0.32313 0.32313c-0.646261-0.646261-0.969391-1.615652-1.615652-2.261912-1.292521-1.938782-2.908173-4.200694-4.523824-6.462606-2.908173-3.877564-7.755128-5.170085-11.955822-3.554434-7.755128 2.585043-15.187125 5.493216-22.619123 8.078258-19.71095 6.785737-39.74503 13.894604-59.45598 21.972862-9.370779 3.554434-14.217734 15.187125-15.510255 22.295993-1.615652 8.401388-1.938782 16.156516-2.585043 24.881035-7.755128-6.785737-15.833386-13.894604-23.588514-21.003471l-0.32313-0.323131c-0.969391-0.646261-1.938782-1.938782-2.585042-3.231303 5.816346-19.38782 14.863995-34.251814 28.435468-46.207636 4.523825-3.877564 4.846955-10.663301 0.969391-14.863995-3.877564-4.523825-10.663301-4.846955-14.863995-0.969391-17.125907 15.187125-28.758599 34.251814-35.544336 58.809719-2.908173 10.663301 8.078258 21.003471 9.69391 22.619123 14.540865 12.925213 29.081729 25.850426 43.299464 38.129378 7.108867 6.139476 14.540865 12.602083 21.649731 18.741559 5.816346 5.170085 9.370779 10.663301 9.37078 15.187125 0 3.231303-0.969391 6.139476-3.877564 9.047649-2.585043 2.585043-9.047649 10.01704-24.234774-2.908173-26.819817-22.942253-54.285895-46.530767-80.459451-70.765541-3.877564-3.877564-7.431997-10.34017-7.755128-14.540865z m40.714421 106.309877c-12.925213 14.217734-25.204165 27.466078-38.452509 39.74503-7.108867 6.785737-9.69391 6.785737-9.69391 6.785737-0.32313 0-2.908173-0.646261-9.370779-10.34017-7.108867-11.309561-13.894604-23.265383-20.357211-34.574945-3.231303-5.493216-6.462607-10.986431-9.693909-16.802777l11.632691-4.846955c15.510256-6.462607 31.666772-13.248343 47.500158-21.003471 6.462607-3.231303 8.401388-2.585043 12.925213 1.938782 7.431997 7.431997 14.863995 14.217734 23.265384 21.326601 1.615652 1.292521 3.231303 2.908173 5.170085 4.523825-4.523825 3.877564-8.724519 8.724519-12.925213 13.248343z m233.946355 262.381824c1.938782 14.863995-8.724519 28.758599-23.911644 31.020511-8.401388 1.292521-16.802777-0.969391-23.588514-6.139476-6.785737-5.170085-10.663301-12.602083-11.632691-21.003471-4.200694-45.561376-18.741559-197.432629-23.911644-244.609656-0.646261-5.493216-5.170085-9.370779-10.663301-9.370779h-30.374251c-5.493216 0-10.01704 4.200694-10.6633 9.370779-2.261912 19.064689-16.479647 169.643421-23.911644 247.517829-0.646261 7.755128-4.523825 14.863995-10.663301 19.71095s-13.894604 7.108867-21.649732 6.139476c-8.401388-0.969391-16.156516-5.493216-21.649732-12.278952-5.493216-6.785737-7.755128-15.187125-6.462606-23.911644 8.724519-71.088672 26.496687-218.4361 30.697381-255.919218 5.816346 2.908173 11.632692 4.523825 17.125907 4.523825 9.047649 0 17.125907-3.877564 24.234774-11.309562 6.462607-7.108867 10.01704-15.510256 9.37078-24.557904 0-0.646261 0-1.615652-0.323131-2.261913 10.663301-4.846955 28.112338-12.602083 39.09877-17.125907 2.908173 3.877564 5.816346 7.431997 8.724518 11.309562 3.554434 4.846955 7.108867 9.370779 10.986432 14.217734 10.986431 13.894604 18.418429 22.295992 29.404859 22.295992 5.493216 0 10.34017-2.261912 14.863995-6.462606 3.554434 29.081729 9.047649 71.411802 14.863995 115.680656 8.401388 57.840328 16.156516 117.942569 20.03408 153.163774z m114.388135-474.678447c-28.112338 18.741559-59.132849 33.282423-89.5071 47.177027-18.418429 8.401388-37.159987 17.125907-55.578416 26.819817-2.261912 1.292521-4.523825 2.585043-6.462606 3.877564-8.078258 5.170085-11.632692 6.785737-16.479647 4.846955-2.585043-1.292521-7.108867-1.938782-12.278952 1.292521 0 0-12.602083 8.078258-12.602083 18.095299 0 11.955822 2.261912 21.972862 7.108867 29.727989 8.401388 14.217734 17.772168 27.789208 27.142948 41.037552 1.615652 2.261912 3.231303 4.846955 4.846954 7.108867-3.231303 4.200694-7.431997 8.724519-9.693909 10.34017-3.231303-2.261912-9.69391-10.34017-12.602083-13.894604-3.554434-4.523825-7.108867-9.370779-10.663301-13.894604-4.523825-5.816346-9.047649-11.632692-13.894604-17.772168-2.908173-3.554434-8.078258-4.846955-12.278952-3.231303-7.431997 2.908173-32.313033 13.894604-46.853897 20.680341-2.261912-2.908173-4.846955-5.816346-7.755128-8.401388-7.108867-6.139476-14.217734-12.602083-21.326601-18.741559 0.32313-0.969391 0.646261-2.261912 0.64626-3.231304 0.32313-3.554434 0.32313-6.785737 0.646261-10.01704 0.32313-9.69391 0.969391-17.125907 2.261912-24.881035v-0.32313c0.32313-2.261912 1.938782-5.493216 3.231303-6.462607 19.064689-7.755128 38.129378-14.217734 58.163459-21.326601 5.170085-1.938782 10.01704-3.554434 15.187125-5.493215l1.938782 2.908172c3.231303 5.493216 7.431997 8.401388 12.278953 9.37078 8.078258 1.292521 14.217734-3.554434 17.772167-6.462607 2.261912-1.615652 4.200694-3.554434 5.816346-5.170085 2.261912-2.261912 4.846955-4.523825 6.462607-5.170085 46.530767-18.095298 95.000316-37.159987 142.823603-54.285895 10.34017-3.877564 21.003471-7.431997 31.343642-10.986431-3.231303 2.261912-6.462607 4.200694-9.69391 6.462607z"
                            fill="#ffffff"
                            p-id="8834"
                          ></path>
                          <path
                            d="M678.896813 403.589776c-3.231303-2.585043-7.755128-3.231303-11.309562-1.615652-25.204165 12.278952-48.792679 23.265383-71.411801 34.251815-13.894604 6.785737-27.142947 13.248343-40.714421 19.71095-4.200694 1.938782-6.462607 6.462607-5.816346 10.986431 0.969391 5.816346 1.615652 11.309561 2.585042 16.479646 0.969391 5.816346 1.938782 11.632692 2.585043 17.125907 1.938782 16.479647 10.986431 28.112338 25.527296 32.636163h0.32313c3.231303 0.969391 6.462607 1.292521 9.69391 1.292522 11.309561 0 21.649732-5.493216 29.404859-16.156517l11.632692-16.479646c14.217734-19.71095 28.758599-40.391291 42.653203-61.071632 0 0 0-0.32313 0.32313-0.32313 3.231303-5.170085 4.523825-10.663301 5.816346-16.802777 0.646261-2.908173 1.292521-6.139476 2.261912-9.69391 0.969391-3.231303-0.32313-7.755128-3.554433-10.34017z m-64.949195 86.275797c-3.877564 5.493216-7.755128 10.986431-11.632692 16.156516-6.139476 8.401388-11.955822 8.078258-16.156516 6.785737-4.200694-1.292521-9.370779-4.200694-10.663301-14.863995-0.646261-6.139476-1.615652-11.955822-2.585043-18.095298-0.32313-2.585043-0.969391-5.493216-1.292521-8.078258 11.309561-5.493216 22.295992-10.986431 33.928684-16.479647 15.833386-7.755128 32.313033-15.510256 49.43894-23.911644-13.248343 19.71095-27.466078 39.4219-41.037551 58.486589z"
                            fill="#ffffff"
                            p-id="8835"
                          ></path>
                        </svg>
                      </el-tooltip>
                    </div>
                    <div
                      class="el-badge-box flex_center"
                      v-if="scope.row?.sanctionType == 'Advisories'"
                    >
                      <el-tooltip
                        effect="dark"
                        content="Advisories"
                        placement="top"
                      >
                        <svg
                          t="1760514186890"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="9132"
                          width="30"
                          height="30"
                        >
                          <path
                            d="M885.76 914.773333H138.24c-46.08 0-78.506667-22.186667-78.506667-52.906666V354.986667c0-30.72 32.426667-52.906667 78.506667-52.906667h747.52c46.08 0 78.506667 22.186667 78.506667 52.906667v506.88c0 30.72-32.426667 52.906667-78.506667 52.906666zM110.933333 856.746667c3.413333 1.706667 13.653333 6.826667 27.306667 6.826666h747.52c15.36 0 23.893333-3.413333 27.306667-6.826666V358.4c-3.413333-1.706667-13.653333-6.826667-27.306667-6.826667H138.24c-15.36 0-23.893333 3.413333-27.306667 6.826667v498.346667z m803.84-496.64z"
                            fill="#ffffff"
                            p-id="9133"
                          ></path>
                          <path
                            d="M411.306667 576.853333h-170.666667c-13.653333 0-25.6-11.946667-25.6-25.6s11.946667-25.6 25.6-25.6h170.666667c13.653333 0 25.6 11.946667 25.6 25.6s-11.946667 25.6-25.6 25.6zM650.24 713.386667h-409.6c-13.653333 0-25.6-11.946667-25.6-25.6s11.946667-25.6 25.6-25.6h409.6c13.653333 0 25.6 11.946667 25.6 25.6s-11.946667 25.6-25.6 25.6zM155.306667 349.866667c-10.24 0-18.773333-5.12-23.893334-15.36-5.12-13.653333 0-27.306667 13.653334-34.133334l273.066666-121.173333c13.653333-5.12 27.306667 0 34.133334 13.653333 5.12 13.653333 0 27.306667-13.653334 34.133334l-273.066666 121.173333c-1.706667 0-5.12 1.706667-10.24 1.706667z"
                            fill="#ffffff"
                            p-id="9134"
                          ></path>
                          <path
                            d="M512 274.773333c-56.32 0-102.4-46.08-102.4-102.4s46.08-102.4 102.4-102.4 102.4 46.08 102.4 102.4-46.08 102.4-102.4 102.4z m0-153.6c-29.013333 0-51.2 22.186667-51.2 51.2s22.186667 51.2 51.2 51.2 51.2-22.186667 51.2-51.2-22.186667-51.2-51.2-51.2z"
                            fill="#ffffff"
                            p-id="9135"
                          ></path>
                          <path
                            d="M861.866667 341.333333c-3.413333 0-6.826667 0-10.24-1.706666l-273.066667-121.173334c-13.653333-5.12-18.773333-20.48-13.653333-34.133333 5.12-13.653333 20.48-18.773333 34.133333-13.653333l273.066667 121.173333c13.653333 5.12 18.773333 20.48 13.653333 34.133333-5.12 10.24-15.36 15.36-23.893333 15.36z"
                            fill="#ffffff"
                            p-id="9136"
                          ></path>
                        </svg>
                      </el-tooltip>
                    </div>
                    <div
                      class="el-badge-box flex_center"
                      v-if="scope.row?.sanctionType == 'Others'"
                    >
                      <el-tooltip
                        effect="dark"
                        content="Others"
                        placement="top"
                      >
                        <svg
                          t="1760929960092"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="8202"
                          width="30"
                          height="30"
                        >
                          <path
                            d="M341.333333 554.666667a42.666667 42.666667 0 1 1 0-85.333334 42.666667 42.666667 0 0 1 0 85.333334z m170.666667 0a42.666667 42.666667 0 1 1 0-85.333334 42.666667 42.666667 0 0 1 0 85.333334z m170.666667 0a42.666667 42.666667 0 1 1 0-85.333334 42.666667 42.666667 0 0 1 0 85.333334zM298.666667 127.957333C298.666667 104.405333 317.824 85.333333 341.12 85.333333h341.76C706.304 85.333333 725.333333 104.490667 725.333333 127.957333v42.752A42.645333 42.645333 0 0 1 682.88 213.333333H341.12C317.696 213.333333 298.666667 194.176 298.666667 170.709333V127.957333zM341.333333 170.666667h341.333334V128H341.333333v42.666667z m-105.173333-42.666667v42.666667S170.666667 170.688 170.666667 170.773333V896s682.666667 0.042667 682.666666-0.106667C853.333333 895.893333 853.333333 170.666667 853.205333 170.666667h-63.296V128h63.296C876.842667 128 896 147.072 896 170.773333v725.12C896 919.509333 877.013333 938.666667 853.333333 938.666667H170.666667a42.666667 42.666667 0 0 1-42.666667-42.773334V170.773333C128 147.157333 147.114667 128 170.752 128h65.408z"
                            fill="#ffffff"
                            p-id="8203"
                          ></path>
                        </svg>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="id"
                  label="Reference"
                  width="230"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{ scope.row?.sanctionReg ? scope.row?.sanctionReg : "-" }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="sanctions"
                  label="Provider Code"
                  min-width="175"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{
                      scope.row?.sanctionSource
                        ? scope.row?.sanctionSource
                        : "-"
                    }}
                  </template>
                </el-table-column>

                <el-table-column
                  prop="companyName"
                  label="Record Source"
                  min-width="275"
                  show-overflow-tooltip
                >
                  <!-- class-name="hover-cell" -->
                  <template slot-scope="scope">
                    <span
                      style="cursor: pointer; color: #f9722c"
                      @click="setid(scope.row?.sourceData)"
                    >
                      {{
                        scope.row?.sourceData ? scope.row?.sourceData : "-"
                      }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="countryName"
                  label="From"
                  min-width="150"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{ scope.row?.startTime ? scope.row.startTime : "-" }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="source"
                  label="To"
                  min-width="150"
                  align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{ scope.row?.endTime ? scope.row.endTime : "-" }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="startTime"
                  label="Status"
                  width="120"
                  align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span
                      v-if="scope.row?.sanctionStatus == 'Suspended'"
                      style="color: #ff6a6a"
                    >
                      {{
                        scope.row?.sanctionStatus
                          ? scope.row.sanctionStatus
                          : "-"
                      }}</span
                    >
                    <span v-else style="color: #1290c9">
                      {{
                        scope.row?.sanctionStatus
                          ? scope.row.sanctionStatus
                          : "-"
                      }}</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="page_i_box">
              <Page
                :totalFont="true"
                :total="page.total"
                :pageSize.sync="page.pageSize"
                :currentPage="page.pageNo"
                @onPageChange="onPageChangeList"
              ></Page>

              <div class="search_rsult_txt line_2">
                {{ page.pageNo }}-{{ page.pageSize }} of over
                {{ page.total | FilterNum }} results for "{{
                  $route.query.keyword
                }}"
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts/core";
import worldJson from "echarts/map/json/world.json";
// import Header from "./header.vue";
import Header from "@/views/newLayout/header.vue";
import Tollbar from "@/views/newLayout/tollbar.vue";
import { color } from "d3";
import { mixins1 } from "@/mixins/index";
import Page from "@/components/page/index.vue";
import {
  getCountryListDetails,
  getCountryListLabel,
} from "@/api/companyApi.js";
export default {
  directives: {
    loadmore: {
      bind(el, binding) {
        const selectWrap = el.querySelector(".el-table__body-wrapper");
        selectWrap.addEventListener("scroll", function () {
          const scrollDistance =
            this.scrollHeight - this.scrollTop - this.clientHeight;
          if (scrollDistance <= 0.5) {
            binding.value(); // 执行绑定的函数
          }
        });
      },
    },
  },
  mixins: [mixins1],
  components: {
    Header,
    Tollbar,
    Page,
  },
  data() {
    return {
      pageTree: {
        pageNo: 1,
        pageSize: 5,
        total: 0,
      },
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      searchForm: {
        termId: "", //精确用
        name: "", //头部用
        termCountry: "",
        termInformationSource: "",
        termSanction: "",
        termPersonal: "",
        sortBy: "",
        CompanyPersonName: "",
        ObjectofSanctions: "",
        SanctionsID: "",
        Status: "",
        Typesofanctions: "",
        ReferenceName: "",
        SourceofSanctions: "",
      },
      SanctionsIDList: [],
      ReferenceNameList: [],
      StatusList: [],
      TypesofanctionsList: [],
      SourceofSanctionsList: [],
      ObjectofSanctionsList: [],
      CompanyPersonNameList: [],
      SourcSanctionsShow: false,
      SourceSanctionsTable: [
        {
          Provider: "US-BIS",
          Description:
            "BIS is responsible for the regulation of exports for national security, foreign policy, and nonproliferation reasons and the enforcement of those regulations. BIS is also charged with administering and enforcing U.S. Antiboycott laws, the Fastener Quality Act, and the reporting provisions of the Chemical Weapons Convention",
          NumberofSanctions: "200",
        },
        {
          Provider: "US-FCC",
          Description:
            "BIS is responsible for the regulation of exports for national security, foreign policy, and nonproliferation reasons and the enforcement of those regulations. BIS is also charged with administering and enforcing U.S. Antiboycott laws, the Fastener Quality Act, and the reporting provisions of the Chemical Weapons Convention",
          NumberofSanctions: "200",
        },
        {
          Provider: "US-DEFENSE",
          Description:
            "The United States Department of Defense (DOD) is an executive branch department of the federal government of the United States charged with coordinating and supervising all agencies and functions of the U.S. government directly related to national security and the United States Armed Forces.",
          NumberofSanctions: "200",
        },
      ],
      CountryRiskCode: "",
      searchCompany: "",
      searchCountry: "",
      searchSanction: "",
      searchSource: "",
      searchPersonal: "",
      CountryRiskTab: "Sanctioned",
      companyList: [],
      countryList: [],
      sourceList: [],
      sanctionList: [],
      personalList: [],
      sanctionStatusList: [],
      tableData: [
        {
          sanctionsId: "10023",
          sanctions: "Company",
          sanctionsCountry: "United States",
          companyName: "Huawei Technologies Co., Ltd.",
          countryName: "China",
          source: "",
          fromTime: "2024-06-28",
          toTime: "2024-06-28",
        },
      ], // 表格数据
      isShowSearch: true,
      isShowSelect: false, // 是否显示复选框
      selectList: [],
      params: {
        page: 1, // 当前页数
        pageSize: 100, // 每页加载的数据条数
      },
      totalCount: 0,
      loading: false, // 加载状态
      hasMore: true, // 是否还有更多数据
      loadingSearch: false, //检索loading
      mapChart: null,
      worldData: [
        {
          name: "China",
          itemStyle: { areaColor: "#F9722C" },
          Countrycode: "CN",
          value: 200,
          emphasis: {
            label: { show: false },
            itemStyle: {
              areaColor: "#FFE000",
            },
          },
        },
        {
          name: "United States",
          Countrycode: "CN",
          value: 200,
          itemStyle: { areaColor: "#F9722C" },
          emphasis: {
            label: { show: false },
            itemStyle: {
              areaColor: "#FFE000",
            },
          },
        },
        {
          name: "Brazil",
          Countrycode: "CN",
          value: 200,
          itemStyle: { areaColor: "#F9722C" },
          emphasis: {
            label: { show: false },
            itemStyle: {
              areaColor: "#FFE000",
            },
          },
        },
        {
          name: "Russia",
          Countrycode: "CN",
          value: 200,
          itemStyle: { areaColor: "#F9722C" },
          emphasis: {
            label: { show: false },
            itemStyle: {
              areaColor: "#FFE000",
            },
          },
        },
        {
          name: "India",
          Countrycode: "CN",
          value: 200,
          itemStyle: { areaColor: "#F9722C" },
          emphasis: {
            label: { show: false },
            itemStyle: {
              areaColor: "#FFE000",
            },
          },
        },
      ],
      barChart: null,
      barWith: 38,
      barXData: [40, 58, 68, 42],
      barXAxis: ["OFAC", "BIS", "US", "CSRC"],
      tollbarList: [
        {
          icon: "icon-youhua",
          name: "Optimize",
          disabled: true,
        },
        {
          icon: "icon-xuanze",
          name: "Select",
          disabled: true,
        },
        {
          icon: "icon-bianji1",
          name: "Edit",
          disabled: true,
          select: true,
        },
        {
          icon: "icon-filter",
          name: "Sort by",
          disabled: true,
          select: true,
        },
        {
          icon: "icon-shoucang1",
          name: "Collect",
          disabled: true,
          select: true,
        },
        {
          icon: "icon-baocun",
          name: "Saved",
          disabled: true,
          select: true,
        },
        {
          icon: "icon-icon_xinyong_xianxing_jijin-307",
          name: "Compare",
          disabled: true,
        },
        {
          icon: "icon-daochu04",
          name: "Export",
          disabled: true,
        },
        {
          icon: "icon-xiazai",
          name: "Download",
          disabled: true,
        },
        {
          icon: "icon-shuaxin",
          name: "Update",
          disabled: true,
        },
        {
          icon: "icon-judan",
          name: "Report Error",
          disabled: true,
        },
        {
          icon: "icon-gudong",
          name: "Share",
          disabled: true,
        },
      ],
      sortList: [
        {
          value: "",
          label: "Default",
        },
        {
          value: "1",
          label: "Ascending",
        },
        {
          value: "2",
          label: "Descending",
        },
      ],
      conditionsList: ["Company Name", "Country", "Information Sources"],
    };
  },
  methods: {
    setid(row) {
      if (row.includes("http")) {
        let routeData = row;
        window.open(routeData, "_blank");
      } else {
        let routeData = "http://" + row;
        window.open(routeData, "_blank");
      }
    },
    // 清空检索条件
    onClearSearch() {
      this.searchForm.ObjectofSanctions = "";
      this.searchForm.SourceofSanctions = "";
      this.searchForm.SanctionsID = "";
      this.searchForm.CompanyPersonName = "";
      this.searchForm.Typesofanctions = "";
      this.page.pageNo = 1;
      this.searchForm.ReferenceName = "";
      this.searchForm.Status = "";
      this.getCountryListLabelArr();
      this.getCountryListDetailsArr();
    },
    getCountryListLabelArr() {
      getCountryListLabel({
        countryCode:
          this.$route.query.Type == "1"
            ? this.$route.query.CountryCode
            : this.$route.query.TargetCountryCode,
        countryName:
          this.$route.query.Type == "2"
            ? this.$route.query.CountryCode
            : this.$route.query.TargetCountryCode,
        sanctionObject: this.searchForm.ObjectofSanctions,
        sanctionSource: this.searchForm.SourceofSanctions,
        sanctionId: this.searchForm.SanctionsID,
        sanctionName: this.searchForm.CompanyPersonName,
        sanctionType: this.searchForm.Typesofanctions,
        sanctionReg: this.searchForm.ReferenceName,
        Status: this.searchForm.Status,
      }).then((res) => {
        if (res.code == 200) {
          this.SanctionsIDList = [];
          this.ObjectofSanctionsList = res.data.sanctionObject;
          this.CompanyPersonNameList = [];
          this.StatusList = res.data.sanctionStatus;
          this.TypesofanctionsList = res.data.sanctionType;
          this.SourceofSanctionsList = res.data.sanctionSource;
          this.ReferenceNameList = res.data.sanctionReg;
        }
      });
    },
    getCountryListDetailsArr() {
      getCountryListDetails({
        countryCode:
          this.$route.query.Type == "1"
            ? this.$route.query.CountryCode
            : this.$route.query.TargetCountryCode,
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
        countryName:
          this.$route.query.Type == "2"
            ? this.$route.query.CountryCode
            : this.$route.query.TargetCountryCode,
        sanctionObject: this.searchForm.ObjectofSanctions,
        sanctionSource: this.searchForm.SourceofSanctions,
        sanctionId: this.searchForm.SanctionsID,
        sanctionName: this.searchForm.CompanyPersonName,
        sanctionType: this.searchForm.Typesofanctions,
        sanctionReg: this.searchForm.ReferenceName,
        Status: this.searchForm.Status,
      }).then((res) => {
        if (res.code == 200 && res.data) {
          this.tableData = res.data.rows;
          this.page.total = res.data.total;
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
      });
    },
    onPageChangeList({ page, size }) {
      this.page.pageNo = page;
      this.page.size = size;
      this.getCountryListDetailsArr();
    },
    closeDialog() {
      this.SourcSanctionsShow = false;
    },

    onPageChangeListTree({ page, size }) {
      this.pageTree.pageNo = page;
      this.pageTree.size = size;
    },
    //获取国家数据
    getContryList() {
      let countryImg = this.getCountryImgUrl(this.$route.query.CountryCode);
      this.CountryRiskCode = require("../../../static" + countryImg);
    },
    // 搜索
    onSearch(params) {
      // 调用检索api
      if (params.selectCode == 1) {
        // 公司
        this.$router.push({
          path: "/sanction/companyList",
          query: {
            selectCode: 1,
            keyword: params.searchKeyword,
          },
        });
      } else if (params.selectCode == 2) {
        // 个人
        this.$router.push({
          path: "/sanction/personList",
          query: {
            selectCode: 2,
            keyword: params.searchKeyword,
          },
        });
      } else if (params.selectCode == 3) {
        // 产品
        this.$router.push({
          path: "/sanction/productList",
          query: {
            selectCode: 3,
            keyword: params.searchKeyword,
          },
        });
      } else if (params.selectCode == 4) {
        // 产品
        this.$router.push({
          path: "/sanction/countryList",
          query: {
            selectCode: 4,
            keyword: params.searchKeyword,
            CountryCode: this.$route.query.CountryCode,
          },
        });
      } else {
        // 国家
        // 参数不同时进行路由替换，否则会报错
        if (params.searchKeyword != this.$route.query.keyword) {
          this.$store.dispatch("app/SetlabelCode", "");
          this.$store.dispatch("app/SetlabelCodeName", "");
          this.$store.dispatch("app/SetarchagAin", true);
          this.$store.commit("setRefreshKey", new Date().getTime());
          this.$router.replace({
            path: "/sanction/countryList",
            query: {
              selectCode: 4,
              keyword: params.searchKeyword,
            },
          });
        }
        // 调用检索api
        if (this.$route.query.keyword) {
          this.params.page = 1;
          //   this.searchForm.name = this.$route.query.keyword;
          //   this.tableData = [];
        }
      }
    },

    // 公司搜索
    async companyMethod(query) {
      //   let res = await getCpSanctionSelectOptions({
      //     name: this.$route.query.keyword,
      //     optionType: 1,
      //     companyOrPerson: 1,
      //     aggregationsKeyWord: query,
      //     termId: "",
      //     termCountry: this.searchForm.termCountry,
      //     termInformationSource: this.searchForm.termInformationSource,
      //   });
      //   this.companyList = res?.data?.options || [];
    },
    // 公司聚焦时
    onFocusCompany(val) {
      if (val) {
        this.getSanctionOptions(this.searchCompany, 1);
      }
    },
    // 国家搜索
    async countryMethod(query) {
      //   let res = await getCpSanctionSelectOptions({
      //     name: this.$route.query.keyword,
      //     optionType: 2,
      //     companyOrPerson: 1,
      //     aggregationsKeyWord: query,
      //     termId: this.searchForm.termId,
      //     termCountry: "",
      //     termInformationSource: this.searchForm.termInformationSource,
      //   });
      //   this.countryList = res?.data?.options || [];
      //   this.countryList = this.countryList.filter((item) => item.name != "");
    },
    // 国家聚焦时
    onFocusCountry(val) {
      if (val) {
        this.getSanctionOptions(this.searchCountry, 2);
      }
    },
    // 信息来源搜索
    async informationMethod(query) {
      //   let res = await getCpSanctionSelectOptions({
      //     name: this.$route.query.keyword,
      //     optionType: 3,
      //     companyOrPerson: 1,
      //     aggregationsKeyWord: query,
      //     termId: this.searchForm.termId,
      //     termCountry: this.searchForm.termCountry,
      //     termInformationSource: "",
      //   });
      //   this.sourceList = res?.data?.options || [];
    },
    // 信息来源聚焦时
    onFocusInformation(val) {
      if (val) {
        this.getSanctionOptions(this.searchSource, 3);
      }
    },
    // 制裁对象搜索
    async sanctionMethod(query) {
      //   let res = await getCpSanctionSelectOptions({
      //     name: this.$route.query.keyword,
      //     optionType: 2,
      //     companyOrPerson: 1,
      //     aggregationsKeyWord: query,
      //     termId: this.searchForm.termId,
      //     termCountry: "",
      //     termInformationSource: this.searchForm.termInformationSource,
      //   });
      //   this.countryList = res?.data?.options || [];
      //   this.countryList = this.countryList.filter((item) => item.name != "");
    },

    // 参数改变时
    onChangeParams(val, key) {
      this.page.pageNo = 1;
      this.getCountryListDetailsArr();
      this.getCountryListLabelArr();
    },

    onChangeSelection(val) {
      this.selectList = val;
    },

    // 清空排序
    onChangeSort(e) {
      this.searchForm.sortBy = e.length > 0 ? e[0] : "";
      if (this.$route.query.keyword) {
        this.params.page = 1;
        this.tableData = [];
      }
    },
    // 表格滚动
    handleScroll() {
      if (this.hasMore && !this.loading) {
        this.loadData();
      }
    },
    // 加载数据
    loadData() {
      let totalPage = Math.ceil(this.totalCount / this.params.pageSize);
      if (this.params.page == totalPage) {
        this.hasMore = false;
      } else {
        this.params.page += 1;
      }
    },
  },
  mounted() {

    this.getContryList();
    this.getCountryListDetailsArr();
    this.getCountryListLabelArr();
  },
  beforeDestroy() {},
};
</script>
<style scoped>
.new-content-country-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
  transition: flex 0.3s;
}

.new-content-sanction-con {
  width: calc(100% - 10px);
  /* height: 738px; */
  display: flex;
  flex-shrink: 0;
  padding: 14px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}

.new-content-sanction-info {
  width: 400px;
  width: 26.23%;
  height: auto;
}

.new-content-sanction-map {
  flex: 1;
  height: 710px;
  background: #f5f5f5;
  border-radius: 4px;
}

.new-content-sanction-title {
  line-height: 22px;
  font-family: "DMSans Bold";
  font-size: 16px;
}

.new-content-sanction-number {
  margin: 16px 0;
  line-height: 38px;
  font-family: "DMSans Bold";
  font-size: 30px;
}

.new-content-sanction-percentage {
  display: flex;
  align-items: center;
  justify-content: start;
  line-height: 18px;
  font-size: 16px;
  color: #666666;
}

.new-content-sanction-percentage i {
  margin-right: 6px;
  font-weight: bold;
  font-size: 22px;
  color: #ff6a6a;
}

.new-content-sanction-percentage span {
  margin-right: 14px;
  font-family: "DMSans Bold";
  font-size: 18px;
  color: #ff6a6a;
}

.new-content-sanction-rise .new-content-sanction-percentage i,
.new-content-sanction-rise .new-content-sanction-percentage span {
  color: #3ebb72;
}

.new-content-sanction-desc {
  width: calc(100% - 10px);
  font-family: "DMSans Bold";
  font-size: 16px;
}

.new-content-country-right .new-content-right {
  flex: none;
  width: calc(100% - 10px);
  height: 722px;
  margin-right: 0 !important;
}

.CountryRisk-head {
  height: 216px;
  background: #f9722c;
  padding: 20px;
}

.CountryImg {
  width: 50px;
  height: 30px;
}

.China_code {
  font-size: 2.57142857rem;
  font-family: "DMSans Bold";
  color: #ffffff;
}

.Country-text {
  color: #ffffff;
  font-size: 1.2857143rem;
}

.CountryRisk-tab {
  height: 110px;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  position: relative;
  top: 30px;
  z-index: 998;
}

.new-content-con {
  padding-top: 46px;
}

.new-search-con {
  padding-top: 15px;
  overflow-y: auto !important;
}

.CountryRisk-tab-item {
  display: inline-block;
  padding: 9px 20px;
  font-size: 1.2857143rem;
}

.CountryRisk-tab-box {
  padding: 5px 20px;
  background: #f5f5f5;
  border-radius: 4px;
}

.CountryRisk-tab-active {
  background: #ffffff;
  border-radius: 4px;
  font-family: "DMSans Bold";
}

.CountryRisk-Card {
  text-align: center;
  width: 32.8%;
  background: #f5f5f5;
  border-radius: 4px;
  padding: 30px 0px;
}

.CountryRisk-Card h1,
.CountryRisk-detail-box span {
  font-size: 40px;
  color: #f9722c;
  font-family: "DMSans Bold";
}

.CountryRisk-Card p {
  font-size: 1.2857143rem;
  font-family: "DMSans Bold";
}

.Country_map_titip span,
.Country_map_titip p,
.CountryRisk-detail-box p {
  font-size: 16px;
  color: #1a2332;
  font-family: "DMSans Bold";
}

/deep/ .el-badge__content {
  background-color: #ffdb01;
  color: #1a2332;
}

/deep/ .el-badge {
  margin-right: 20px;
}

.CountryRisk-tab-Head {
  /* padding: 0 40px; */
}

.CountryRisk-detail-box {
  text-align: center;
  width: 23%;
  border-left: 1px solid #ccc;
}

.CountryRisk-detail-box-one {
  text-align: center;
  width: 31%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.CountryRisk-detail-box-one span {
  font-size: 30px;
  font-family: "DMSans Bold";
  padding: 0 10px;
}

@media (max-width: 1440px) {
  .CountryRisk-detail-box span {
    font-size: 24px;
  }

  .CountryRisk-Card p {
    font-size: 16px;
  }

  /deep/ .el-table th.el-table__cell {
    height: 50px !important;
  }

  .CountryRisk-detail-box-one span {
    font-size: 24px;
  }
}

/deep/ .el-table th.el-table__cell {
  height: 55px !important;
}

/deep/ .el-table td.el-table__cell {
  height: 55px !important;
}
</style>
